export const getEmployeeState = (state: any) => state.employee
